import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../BaseUrl/apiClient";
import "../css/App.css";
import "../css/color.css";
import _ from "lodash";
import TokenService from "../service/TokenService";
import SriyanshCardHeader from "../components/CardHeader";
import SearchTextField from "../CustomComponant/SearchTextField";
import ListDynamicTable from "../CustomComponant/ListDynamicTable";
import {DISPLAY_PAGE_SIZE} from "../constants/constants"


function IndentDataSearch() {

  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState("");
  const [srcinddata, setSrcinddata] = useState("");

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;

  // Debounced search function
  // const fetchData = useCallback(
  //   _.debounce(async (searchTerm) => {
  //     try {
  //       const response = await apiClient.post("/searchIndentList", {
  //         uname: uname,
  //         limit: String(pageSize * (currentPage - 1)),
  //         offset: String(pageSize),
  //         srcinddata: searchTerm,
  //       });
  //       setReturnData(response.data);
  //       setTotalRows(response.data[0]?.totaldata || 0);
  //     } catch (error) {
  //       setReturnData([]);
  //       setTotalRows(0);
  //     }
  //   }, 300),
  //   [uname, currentPage, pageSize]
  // );

  // useEffect(() => {
  //   fetchData(srcinddata);
  // }, [srcinddata, fetchData]);

  useEffect(() => {
  const handler = setTimeout(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.post("/searchIndentList", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: srcinddata,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);
      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      }
    };

    fetchData();
  }, 300); // debounce delay

  // Cleanup to avoid multiple timeouts
  return () => {
    clearTimeout(handler);
  };
}, [srcinddata, currentPage, pageSize, uname]);


  const handleRowClick = (row) => {
    // Handle row click action with the row data
    if (!row.ponumber)
    {
      alert("PO Not Generated");
    }
    else
    {
      viewData(row.ponumber, row.ponumber);
    }
   
    //  console.log('Row data:', row);
  };

  const viewData = (e) => {
    navigate("searchpodata", {
      state: {
        po_id: e,
      },
    });
  };

  const columns = [
    "indentnumber",
    "itemname",
    "indreceiptdate",
    "ConsigneeCode",
    "ponumber",
  ]; // keys from your data objects
  const columnNames = [
    "Indent Number",
    "Item Name",
    "Indent Date",
    "Consignee",
    "PO Number",
   
  ];

  return (
    <div>
      {/* <SriyanshCardHeader Title="Search by Indent Number" /> */}
      <Card className="Formcard">

      <div className="input-groupHeading">
      Search by Indent Number

            </div>
        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}
          {currentPage === 1 ? (
            <SearchTextField
              label="Indent Number"
              value={srcinddata}
              title="Enter Indent Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search Indent">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          <ListDynamicTable
            columns={columns}
            columnNames={columnNames}
            data={returnData}
            totalRows={totalRows}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onRowClick={handleRowClick}
          />
        </CardContent>
      </Card>
    </div>
  );
}


export default IndentDataSearch